import React from 'react';
import { ErrorDisplayType } from 'scbk-services';
import { create } from 'zustand';

/**
 * Global Error Info
 */
export interface ErrorInfo {
    code?: string;
    title?: string;
    description?: string;
    status?: number;
    displayType?: ErrorDisplayType;
    errorMessage?: string | React.ReactNode;
    errorGuideMessage?: string[];
    errorLocation?: string;
    errorModule?: string;
    nextPage?: string;
    nextPageParameters?: Record<string, unknown>;
    errorPageParameters?: Record<string, unknown>; // 보안매체 검증시 error 여부 및 긴급장애 error 여부
    errorMenuId?: string; // ASIS : ERROR_AFTER_MOVE_MENU_ID : 에러페이지 이후 이동할 menuId
    errorMenuParameters?: Record<string, unknown>; // ERROR_AFTER_MOVE_PARAMETER : 에러페이지 이후 이동할 페이지에 전달할 parameter
    clearHistory?: boolean; // history clear 여부 2026.06.11 뱅킹팀 요청 사항
    onConfirm?: () => Promise<void> | void;
}

/**
 * Global Error Store 상태
 */
interface GlobalErrorState {
    errorInfo: ErrorInfo | undefined;
    setErrorInfo: (error: ErrorInfo) => void;
    clear: () => void;
}

/**
 * Global Error Store 정의
 */
const useGlobalErrorStore = create<GlobalErrorState>()((set) => ({
    errorInfo: undefined,
    setErrorInfo: (error: ErrorInfo) => {
        set({
            errorInfo: { ...error },
        });
    },
    clear: () => set({ errorInfo: undefined }),
}));

export { useGlobalErrorStore };
